import { connect } from 'react-redux'
import Membership from '../../components/membership-request/Membership'
import {
  getMembershipNewRequests,
  getMembershipProcessedRequests,
  setActiveMembership
} from '../../state/actions/membership_request/'
import { getMemberships } from '../../state/selectors/'
import { IMembership } from '../../types'
import { IStoreState } from '../../types/'
import { getCurrentOrganizationId } from '../../state/reducers/organizations'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    ...ownProps,
    currentOrgId: getCurrentOrganizationId(state),
    items: getMemberships(state),
    activeRequestType: '',
    isModalOpen: state.membership.isModalOpen
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getMembershipNewRequests: (organizationId: string, page?: number) => {
      dispatch(getMembershipNewRequests(organizationId, page))
    },
    getMembershipProcessedRequests: (organizationId: string) => {
      dispatch(getMembershipProcessedRequests(organizationId))
    },
    toggleMembershipModal: (membership: IMembership) => dispatch(setActiveMembership(membership))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Membership)



// WEBPACK FOOTER //
// ./src/containers/membership-request/Membership.ts